import LokiJSAdapter from '@nozbe/watermelondb/adapters/lokijs';
import logger from '@nozbe/watermelondb/utils/common/logger';

import schema from './schema';

// @ts-ignore
logger.silence();

const adapter = new LokiJSAdapter({
  dbName: 'library',
  schema,
  // @ts-ignore
  useWebWorker: false,
  useIncrementalIndexedDB: true,
  // These two options are recommended for new projects:
  // It's recommended you implement this method:
  // onIndexedDBVersionChange: () => {
  //   // database was deleted in another browser tab (user logged out), so we must make sure we delete
  //   // it in this tab as well
  //   if (checkIfUserIsLoggedIn()) {
  //     window.location.reload()
  //   }
  // },
});

export default adapter;
